import styles from './styles.module.css';
import Loader from '../Form/Loader';

type ContainerLoaderProps = {
  fullscreen?: boolean;
};

function ContainerLoader({ fullscreen = false }: ContainerLoaderProps) {
  return (
    <div
      className={
        fullscreen
          ? styles.fullscreenLoadingWrapper
          : styles.adminLoadingWrapper
      }
    >
      <Loader size="large" />
    </div>
  );
}

export default ContainerLoader;
